// import core & vendor packages below
import { Modal, Button } from 'react-bootstrap';

// import components below
import ModalUI from 'components/UI/ModalUI';

// import assets below
import './FinalizeDischargeModal.scss';
import { ReactComponent as CloseSVG } from 'assets/svg/circle-xmark.svg';

// main componet
const FinalizeDischargeModal = (props) => {
  const { status, onToggle, onConfirm } = props;

  return (
    <div className='finalizeDischargeModal'>
      <ModalUI>
        <Modal.Dialog>
          <Modal.Header>
            <h4>Add Service Unit</h4>
            <Button onClick={() => onToggle(!status)} variant='transparent'>
              <CloseSVG />
            </Button>
          </Modal.Header>
          <Modal.Body>
            <div className='finalizeDischargeModal__content'>
              <div className='finalizeDischargeModal__body'>
                <h6>
                  Are you sure you want to submit and finalize the Discharge Checklist? You will no
                  longer be able to edit the information once finalized.
                </h6>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant='light-blue'
              onClick={() => {
                onToggle(!status);
                onConfirm((prevState) => !prevState);
              }}
            >
              FINALIZE AND PROCEED TO CLEARANCE REQUEST
            </Button>
            <Button onClick={() => onToggle(!status)} variant='cancel'>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal.Dialog>
      </ModalUI>
    </div>
  );
};

export default FinalizeDischargeModal;
